module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/play-circle-35d83a1992677a32c464fc4063019c7a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/play-circle.svg
// module id = N+Fk
// module chunks = 24